import { createSlice } from '@reduxjs/toolkit';

export const skuItemsSlice = createSlice({
  name: 'skuItems',
  initialState: {
    skuItems: [],
    loading: false,
    error: null,
    pagination: {
      current: 1,
      pageSize: 25,
      total: 0
    },
    filters: {
      searchText: '',
      selectedFulfillmentChannel: 'all',
      selectedStatus: 'all',
      selectedSellerAccount: 'all'
    }
  },
  reducers: {
    setSkuItems: (state, action) => {
      state.skuItems = action.payload;
    },
    setFilteredSkuItems: (state, action) => {
      state.skuItems = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  }
});

export const {
  setSkuItems,
  setFilteredSkuItems,
  setLoading,
  setError,
  setPagination,
  setFilters
} = skuItemsSlice.actions;

export default skuItemsSlice.reducer;